export class AlunoFrequencia {
  /** id da linha de frequência */
  id?: string;
  turmaId?: string;
  turmaNome?: string;
  pessoaId?: string;
  pessoaNome?: string;
  /** Celular vindo da API em {@code FrequenciaRegistroDto.pessoaTelefone} */
  pessoaTelefone?: string | null;
  data?: string;
  fotoDocumentoId?: string | null;
  /** Checkbox marcado = true (igual ao JSON) */
  presente?: boolean;
  presenteMissa?: boolean;
  /** Da turma/itinerário: exige coluna de presença na missa ({@link FrequenciaRegistroDto.frequenciaMissa}) */
  frequenciaMissa?: boolean;

  constructor(data?: Partial<AlunoFrequencia>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
